import { render, staticRenderFns } from "./GlobalParameterValue.vue?vue&type=template&id=80443a10&"
import script from "./GlobalParameterValue.vue?vue&type=script&lang=ts&"
export * from "./GlobalParameterValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports